"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticClassName = exports.gradient = void 0;
require("./gradient.css");
var _zIndex = require("@cbhq/cds-common/tokens/zIndex");
var _tokens = require("../tokens");
var _linaria = require("../utils/linaria");
const staticClassName = 'cds-gradient';
exports.staticClassName = staticClassName;
const baseGradient = "cds-baseGradient-bywydz";
const gradient = {
  left: (0, _linaria.cx)(staticClassName, `${staticClassName}--left`, baseGradient),
  right: (0, _linaria.cx)(staticClassName, `${staticClassName}--right`, baseGradient)
};
exports.gradient = gradient;